<div>
  <app-header></app-header>
</div>

<div class="inner-wraper">
  <div class="common-view">
    <router-outlet></router-outlet>

  </div>
</div>

<div>
  <app-footer></app-footer>
</div>



